import http from '@/axios/http'
import store from '@/store'
import { getuser_id } from "@/localStorage/localStorage";

//历史告警
export function getHistoryAlarmList() {
    const data = {
        user_id: getuser_id(),
        offset: 50,
        limit: 50
    }
    return http({
        url: '/api/alarm/getHistoryAlarmList',
        method: 'post',
        data
    })
}